import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'tnc.title',
    defaultMessage: 'Terms & Condition',
  },
  create: {
    id: 'tnc.create',
    defaultMessage: 'Create Terms & Condition',
  },
  table: {
    no: {
      id: 'tnc.table.no',
      defaultMessage: 'No',
    },
    id: {
      id: 'tnc.table.id',
      defaultMessage: 'TNC ID',
    },
    name: {
      id: 'tnc.table.name',
      defaultMessage: 'Terms & Condition Name',
    },
    version: {
      id: 'tnc.table.version',
      defaultMessage: 'Latest Version',
    },
  },
});
